import { NavLink } from "react-router-dom";
import { navItems } from "../../data/site";

export function Header() {
  return (
    <header className="topbar" aria-label="Primary navigation">
      <NavLink className="brand-lockup" to="/" aria-label="reviewbub home">
        <img src="/logo-horizontal.png" alt="reviewbub" />
        <span>Author PR Command Center</span>
      </NavLink>
      <nav className="nav-links page-nav" aria-label="Pages">
        {navItems.map((item) => (
          <NavLink className={({ isActive }) => isActive ? "active" : ""} end={item.to === "/"} key={item.to} to={item.to}>
            {item.label}
          </NavLink>
        ))}
      </nav>
      <NavLink className="primary-action" to="/packages">Compare Packages</NavLink>
    </header>
  );
}
